import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { LoteAgendamento } from "../../../../services/LoteAgendamento";

export const useVisualizarLoteAgendamento = (uuid?: string) => {
  const query = useQuery({
    queryKey: ["lote-agendamento-visualizar", uuid],
    queryFn: () => LoteAgendamento.visualizar(uuid ?? ""),
    select: (response) => response.data,
    enabled: Boolean(uuid),
  });

  useEffect(() => {
    if (!query.isError) return;

    const {
      response: {
        data: { mensagem },
      },
    } = query.error as any;

    toast.error(mensagem);
  }, [query.isError]);

  return query;
};
